// SafetyHub Admin Application Entry Point
// Version: 2026.01.22-2
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

declare const __APP_VERSION__: string;

// Sentry 초기화
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_ADMIN,
  environment: import.meta.env.VITE_ENV || 'development',
  release: `safetyhub-admin@${__APP_VERSION__}`,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: import.meta.env.VITE_ENV === 'production' ? 0.5 : 1.0,
  enabled: import.meta.env.VITE_ENV === 'production' && !!import.meta.env.VITE_SENTRY_DSN_ADMIN,
});

function SentryFallback() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>오류가 발생했습니다</h1>
      <p style={{ color: '#666', marginBottom: '1.5rem' }}>예기치 않은 오류가 발생했습니다. 페이지를 새로고침해 주세요.</p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '0.75rem 1.5rem', backgroundColor: '#1e40af', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '1rem' }}
      >
        새로고침
      </button>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
